export default "__VITE_ASSET__70WsYjy1__"